<template>
  <div id="app">
    <portal-target name="page-shadow"></portal-target>
    <portal-target name="sidebar-app-info"></portal-target>
    <portal-target name="sidebar-municipalities-index"></portal-target>
    <portal-target name="sidebar-position-new"></portal-target>
    <portal-target name="sidebar-position-saved"></portal-target>
    <portal-target name="sidebar-position-index"></portal-target>
    <portal-target name="sidebar-categories-index"></portal-target>
    <portal-target name="sidebar-position-edit"></portal-target>
    <portal-target name="sidebar-position-detail-index"></portal-target>
    <portal-target name="sidebar-position-detail-map-view"></portal-target>
    <portal-target name="sidebar-position-detail-index-deleted"></portal-target>
    <portal-target name="sidebar-position-detail-index-starred"></portal-target>
    <portal-target name="sidebar-position-detail-index-polygon"></portal-target>
    <portal-target name="position-detail-unselected"></portal-target>
    <portal-target name="position-detail-feature-point"></portal-target>
    <portal-target name="simple-modal"></portal-target>
    <template v-if="layoutHome">
      <LayoutHome />
    </template>
    <template v-if="layoutPosition">
      <LayoutPosition />
    </template>
  </div>
</template>

<script>
import LayoutHome from "@/components/LayoutHome.vue";
import firebase from "firebase/app";
import "firebase/messaging";
import PublicApi from "@/services/PublicApi.js";
import PrivateApi from "@/services/PrivateApi.js";
import LoadOrReturnApp from "@/services/LoadOrReturnApp.js";
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories.js";
import LoadOrReturnGemeentes from "@/services/LoadOrReturnGemeentes.js";
import LoadOrReturnPositions from "@/services/LoadOrReturnPositions.js";
import gmapsInit from "@/utils/gmaps";

export default {
  metaInfo() {
    return {
      title: "OmgevingsAlert",
      meta: [
        { name: "theme-color", content: "#6DCC00", vmid: "theme-color" },
        {
          name: "description",
          content:
            "Deze app toont je de actuele vergunningsaanvragen voor de omgevingsvergunningen bij jou in de buurt (of rond een ander adres naar keuze)."
        }
      ]
    };
  },
  created() {
    let self = this;

    let storedToken = this.$store.state.ui.oaAuthToken;
    if (!storedToken) {
      PublicApi()
        .post("device", {
          os: "web-fcm",
          app: "3c9959b4-37be-4ec6-9e80-ccd4935d71a6"
        })
        .then(function(response) {
          let auth_token = response.data.auth_token;
          self.$store.commit("setOaAuthToken", auth_token);
          storedToken = auth_token;
          self.postDeviceCallback();
        });
    }
    if (storedToken) {
      this.postDeviceCallback();
    }

    if (this.$route.matched.filter(x => x.path == "/gemeentes/:id").length) {
      let id = this.$route.params.id;

      LoadOrReturnGemeentes().then(function(gemeentes) {
        let availableMunicipalities = gemeentes.data.filter(
          x => x.payment_status == "paid" || x.payment_status == "trial"
        );
        let municipality = availableMunicipalities.filter(x => x.id == id);
        if (municipality.length) {
          self.setActiveMunicipality(municipality[0], false);
        }
      });
    }
    if (this.$route.matched.filter(x => x.path == "/positions/:id").length) {
      let id = this.$route.params.id;

      LoadOrReturnPositions().then(function(positions) {
        let allPositions = positions.data.filter(x => x.id == id);

        if (allPositions.length > 0) {
          self.setActivePosition(allPositions[0]);
        } else {
          self.$router.push("/");
        }
      });
    }
  },
  components: {
    LayoutHome,
    LayoutPosition: () => import("@/components/LayoutPosition.vue")
  },
  computed: {
    layoutHome() {
      return this.$store.state.ui.layoutHome;
    },
    layoutPosition() {
      return this.$store.state.ui.layoutPosition;
    },
    updatedDevice() {
      return this.$store.state.ui.updatedDevice;
    }
  },
  methods: {
    setActivePosition(position) {
      this.$store.commit("setActivePosition", position);
      this.$store.commit("closeLayoutHome");
      this.$store.commit("openLayoutPosition");
      this.$store.commit("openSidebarPositionDetailIndex");
    },
    setActiveMunicipality(municipality, locationSet) {
      if (locationSet) {
        this.setActiveMunicipalityCallback(municipality);
      } else {
        if (municipality.app_asset) {
          let municipalityLatitude = municipality.app_asset.latitude;
          let municipalityLongitude = municipality.app_asset.longitude;
          this.$store.commit("setGpsLatitude", municipalityLatitude);
          this.$store.commit("setGpsLongitude", municipalityLongitude);
          this.setActiveMunicipalityCallback(municipality);
        } else {
          let self = this;
          let municipalityName = municipality.name;

          gmapsInit().then(function(google) {
            var geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: municipalityName }, function(
              results,
              status
            ) {
              if (status === "OK") {
                let municipalityLatitude = results[0].geometry.location.lat();
                let municipalityLongitude = results[0].geometry.location.lng();
                self.$store.commit("setGpsLatitude", municipalityLatitude);
                self.$store.commit("setGpsLongitude", municipalityLongitude);
                self.setActiveMunicipalityCallback(municipality);
              }
            });
          });
        }
      }
    },
    setActiveMunicipalityCallback(municipality) {
      this.$store.commit("setActiveMunicipality", municipality);
      this.$store.commit("openSidebarPositionNew");
      if (this.$route.params.id != municipality.id) {
        this.$router.push(`/gemeentes/${municipality.id}`);
      }
    },
    postDeviceCallback() {
      let self = this;
      this.loadData();
      if ("PushManager" in window) {
        const messaging = firebase.messaging();

        Notification.requestPermission().then(function(permission) {
          if (permission === "granted" && !self.updatedDevice) {
            firebase
              .messaging()
              .getToken()
              .then(token => {
                PrivateApi()
                  .put("device", {
                    os: "web-fcm",
                    token: token
                  })
                  .then(function() {
                    self.$store.commit("setUpdatedDevice");
                  });
              });
          }
          messaging.onTokenRefresh(() => {
            firebase
              .messaging()
              .getToken()
              .then(refreshedToken => {
                console.log("Token refreshed.");

                PrivateApi()
                  .put("device", {
                    os: "web-fcm",
                    token: refreshedToken
                  })
                  .then(function() {
                    console.log("send refreshed token to server");
                  });
              })
              .catch(err => {
                console.log("Unable to retrieve refreshed token ", err);
              });
          });
        });

        if (this.updatedDevice) {
          messaging.onMessage(function(payload) {
            console.log("payload");
            console.log(payload);
            let notification = new Notification(payload.notification.title, {
              body: payload.notification.body
            });
            notification.onclick = function() {
              parent.focus();
              window.focus();
              this.close();
            };
          });
        }
      }
    },
    loadData() {
      let self = this;

      LoadOrReturnCategories();
      LoadOrReturnApp();
      LoadOrReturnGemeentes();
      LoadOrReturnPositions().then(function(positions) {
        self.$store.commit("setLoadedPositions", positions);

        if (positions.data.length > 0) {
          self.$store.commit("closeModalAddLocation");
        } else {
          self.$store.commit("openModalAddLocation");
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:after,
blockquote:before,
q:after,
q:before {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  text-decoration: none;
}

img {
  max-width: 100%;
}
/* reset end */

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

html {
  height: 100%;
  position: relative;
}

body {
  color: $color-black-1;
  font-family: Lato;
  height: 100%;
}

#app {
  height: 100%;
  overflow-x: hidden;
}

.mt-1 {
  margin-top: $spacing-1;
}
.mt-2 {
  margin-top: $spacing-2;
}
.mt-3 {
  margin-top: $spacing-3;
}
.mt-4 {
  margin-top: $spacing-4;
}
.mt-5 {
  margin-top: $spacing-5;
}
.mt-6 {
  margin-top: $spacing-6;
}
.mt-7 {
  margin-top: $spacing-7;
}

.pac-container {
  z-index: 5000;
}

button {
  border: 0;
  cursor: pointer;
  padding: 0;
  background: transparent;
}

.vue-slider-process {
  background-color: #000 !important;
}

.vue-slider-dot-handle-focus {
  box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32) !important;
}

.tns-outer {
  padding: 0 !important;
}
.tns-outer [hidden] {
  display: none !important;
}
.tns-outer [aria-controls],
.tns-outer [data-action] {
  cursor: pointer;
}
.tns-slider {
  -webkit-transition: all 0s;
  -moz-transition: all 0s;
  transition: all 0s;
}
.tns-slider > .tns-item {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.tns-horizontal.tns-subpixel {
  white-space: nowrap;
}
.tns-horizontal.tns-subpixel > .tns-item {
  display: inline-block;
  vertical-align: top;
  white-space: normal;
}
.tns-horizontal.tns-no-subpixel:after {
  content: "";
  display: table;
  clear: both;
}
.tns-horizontal.tns-no-subpixel > .tns-item {
  float: left;
}
.tns-horizontal.tns-carousel.tns-no-subpixel > .tns-item {
  margin-right: -100%;
}
.tns-no-calc {
  position: relative;
  left: 0;
}
.tns-gallery {
  position: relative;
  left: 0;
  min-height: 1px;
}
.tns-gallery > .tns-item {
  position: absolute;
  left: -100%;
  -webkit-transition: transform 0s, opacity 0s;
  -moz-transition: transform 0s, opacity 0s;
  transition: transform 0s, opacity 0s;
}
.tns-gallery > .tns-slide-active {
  position: relative;
  left: auto !important;
}
.tns-gallery > .tns-moving {
  -webkit-transition: all 0.25s;
  -moz-transition: all 0.25s;
  transition: all 0.25s;
}
.tns-autowidth {
  display: inline-block;
}
.tns-lazy-img {
  -webkit-transition: opacity 0.6s;
  -moz-transition: opacity 0.6s;
  transition: opacity 0.6s;
  opacity: 0.6;
}
.tns-lazy-img.tns-complete {
  opacity: 1;
}
.tns-ah {
  -webkit-transition: height 0s;
  -moz-transition: height 0s;
  transition: height 0s;
}
.tns-ovh {
  overflow: hidden;
}
.tns-visually-hidden {
  position: absolute;
  left: -10000em;
}
.tns-transparent {
  opacity: 0;
  visibility: hidden;
}
.tns-fadeIn {
  opacity: 1;
  filter: alpha(opacity=100);
  z-index: 0;
}
.tns-normal,
.tns-fadeOut {
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}
.tns-vpfix {
  white-space: nowrap;
}
.tns-vpfix > div,
.tns-vpfix > li {
  display: inline-block;
}
.tns-t-subp2 {
  margin: 0 auto;
  width: 310px;
  position: relative;
  height: 10px;
  overflow: hidden;
}
.tns-t-ct {
  width: 2333.3333333%;
  width: -webkit-calc(100% * 70 / 3);
  width: -moz-calc(100% * 70 / 3);
  width: calc(100% * 70 / 3);
  position: absolute;
  right: 0;
}
.tns-t-ct:after {
  content: "";
  display: table;
  clear: both;
}
.tns-t-ct > div {
  width: 1.4285714%;
  width: -webkit-calc(100% / 70);
  width: -moz-calc(100% / 70);
  width: calc(100% / 70);
  height: 10px;
  float: left;
}

.tns-nav {
  display: none;
}
</style>
